/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Approval_Failed_LabelInputs */



/**
* | output |
* | --- |
* | "Approval Failed" |
*
* @param {Style_Guide_Manager_Approval_Failed_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_approval_failed_label = /** @type {((inputs?: Style_Guide_Manager_Approval_Failed_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Approval_Failed_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approbation echouee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Genehmigung fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approvazione fallita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Одобрение не пройдено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobación fallida")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("审批失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("承認に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुमोदन विफल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A aprovação falhou.")
	return /** @type {LocalizedString} */ ("Approval Failed")
});